export const isPhoneNumber = (value: string): boolean => REGEX.PHONE_NUMBER.test(value)

export const isMobilePhoneNumber = (value: string): boolean => REGEX.MOBILE_PHONE_NUMBER.test(value)

export const isPostalCode = (value: string): boolean => REGEX.POSTAL_CODE.test(value)

export const isFiscalCode = (value: string): boolean =>
  REGEX.FISCAL_CODE.test(value.replace(/ /g, ''))

export const isIvaCode = (value: string): boolean => REGEX.IVA_CODE.test(value)

export const isStreetNumber = (value: string): boolean => REGEX.STREET_NUMBER.test(value)

const REGEX = {
  PHONE_NUMBER: /^(\+351|00351|351)?\d{9}$/,
  MOBILE_PHONE_NUMBER: /^(\+351|00351|351)([9]{1})(6|3|2|1{1})([0-9]{7})$/,
  POSTAL_CODE: /^\d{4}-\d{3}$/,
  FISCAL_CODE:
    /^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/,
  IVA_CODE: /^\d{9}$/,
  STREET_NUMBER: /[0-9a-z]+$/i,
}

export const isVatId = (value: string): boolean => REGEX.IVA_CODE.test(value)
